


































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import VJsonschemaForm from "@pan-gms/vuetify-jsonschema-form";
import LeftNavigationComponent from "./LeftNavigation.vue";
import TopNavigationComponent from "./TopNavigation.vue";
import LiveSummaryComponent from "./LiveSummary.vue";
import SubmitComponent from "./Submit.vue";
import NavButtons from "@/components/common/Buttons/NavButtons.vue";
import { AppConstants as _app } from "@/shared/app.constants";
import { DueDeliganceAssessment } from "@/entities";
import AuthService from "@/services/auth.service";

const namespace: string = "assessmentForm";
const auth = new AuthService();
@Component({
  components: {
    TopNavigationComponent,
    VJsonschemaForm,
    LeftNavigationComponent,
    LiveSummaryComponent,
    SubmitComponent,
    NavButtons
  }
})
export default class AssessmentFormComponent extends Vue {
  @Prop() appData: any;
  @Prop() reviewId: any;
  @Prop() saveStatus: any;
  @Prop() isDirty: boolean = false;
  @Prop() options: any;
  @Prop() entity: any;
  @Action("updateDDactiveTab", { namespace }) updateKey: any;
  @Getter("dueDeliganceAssessment", { namespace }) form: DueDeliganceAssessment;
  @Getter("appSectionTemplate", { namespace }) appSectionTemplate: any;
  @Getter("appSection", { namespace }) appSectionData: any;
  @Getter("rootTemplate", { namespace }) schema: any;
  @Action("showNotification", { namespace: "application" }) showNotification: any;
  @Action("dirtySaveDiligence", { namespace }) dirtySaveDiligence: any;
  @Action("submit", { namespace }) submitReviewData: any;
  @Action("saveReviewData", { namespace }) saveReviewData: any;
  @Getter("_appUser", { namespace: "RootApp" }) _username!: string;
  formValid = true;
  schemaformKey: number = 0;

  mounted() {
    // this.$emit("userDetails", this.options);
  }

  /** navigation button action */
  navigate(key) {
    this.saveDirty(() => {
      this.updateKey(key);
      window.location.hash = `#${key}`;
      this.$emit('clearDirty', false);
    });
  }

  // get options() {
  //   return {
  //     userInfo: {
  //       userName: this._username
  //     },
  //     modifiedAt: this.formattedDate(),
  //     insightData: this.appSectionData,
  //     insightSchema: this.appSectionTemplate,
  //     downloadAction: this.$services.document.download
  //   };
  // }

  /** date conversion */
  formattedDate() {
    let date: any;
    if (this.form.data.auditInfo) {
      date = this.form.data.auditInfo.updatedDate
        ? this.form.data.auditInfo.updatedDate
        : new Date();
    } else {
      date = new Date();
    }
    return this.$services.format.formatUTC(date);
  }

  get auditInfo() {
    let opt = this.options;
    opt.modifiedAt = this.formattedDate();
    return opt;
  }

  saveDirty(callback: any) {
    const self = this;
    if (this.isDirty) {
      let datum = {
        id: self.reviewId,
        data: self.form.data,
        context: "dueDiligence",
        entity: self.entity
      };
      this.dirtySaveDiligence(datum).then(res => {
        if (res.Result === "OK") {
          callback();
        }
      });
    } else {
      callback();
    }
  }

  submitAssessment() {
    const self = this;
    let {appSummary, validations} = self.$services.reviewinternal.dueDiligenceSummary(
      self.form.templates,
      self.form.data
    );
    this.form.validationMessages = validations;
    if (appSummary.propsCount != appSummary.filledProps) {
      this.form.showValidationDialog = true;
      // this.showNotification({
      //   text: "Please score all sections to proceed",
      //   color: "error"
      // });
    } else {
      let datum = {
        id: self.reviewId,
        data: self.form.data,
        context: "dueDiligence",
        entity: self.entity
      };
      this.saveReviewData(datum).then(res => {
        if (res.Result === "OK") {
          this.submitReviewData(datum).then(data => {
            if (data) {
              const key: string = "intReviewSubmitted";
              this.$router.push({
                name: "genericNotification",
                query: { msgId: key }
              });
            }
          });
        }
      });
    }
  }

  /**  update the sub menu on left panel selection */
  subMenuChanged(selectedMenu, key) {
    this.saveDirty(() => {
      this.updateKey(key);
      window.location.hash = `#${key}`;
      this.$emit('clearDirty', false);
    });
    this.schemaformKey += 1;
    // reset scroll position
    if (this.$refs.ddReview) {
      this.$refs.ddReview["scrollTop"] = 0;
    }
    if (this.$refs.submitt) {
      this.$refs.submitt["scrollTop"] = 0;
    }
  }

  /** get child schema properties to populate the left panel*/
  get subSchema(): any {
    if (this.form.templates && this.form.templates.properties) {
      var schema = this.form.templates.properties[this.form.selectedKey];
      if(schema)
        schema["x-virtual"] = false;
      return schema;
    } else {
      return {};
    }
  }

  /** application data */
  get datum(): any {
    return this.appData;
  }

  get totalRating(): any {
    if (this.appData) {
      return Object.keys(this.appData).reduce((total, key) => {
        if (this.appData[key] && this.appData[key].score) {
          total = total + parseInt(this.appData[key].score);
        }
        return total;
      }, 0);
    } else {
      return 0;
    }
  }

  get riskLevel(): any {
    return this.totalRating <= 25
      ? "LOW"
      : this.totalRating <= 40
      ? "MEDIUM"
      : "HIGH";
  }

  saveComment()
  {
    this.$emit('commentSave',{});
  }

  /** top menu change event */
  topMenuChanged(key) {
    this.$emit("change", key);
  }
  showError(e) {
    console.log(e);
  }
  /** change event */
  showChange(e) {
    this.$emit("input", true);
  }
  showInput(val) {
    this.$emit("input", true);
  }
  @Watch("appData") chng(val) {
    this.schemaformKey += 1;
  }
  @Watch("totalRating") ratingChange(value) {
    this.appData.totalScore = value;
    this.appData.riskLevel =
      value <= 25 ? "LOW" : value <= 40 ? "MEDIUM" : "HIGH";
  }
  @Watch("riskLevel") riskLevelChange(value) {
    this.appData.riskLevel = value;
  }
}
